import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SelectIDType.css';
import {
  ArrowForwardRounded,
  OpenInNew
} from '@mui/icons-material';
import {
  BackButton,
  EnterpriseButton,
  EnterpriseCard,
  EnterpriseGrid,
  EnterpriseHero,
  EnterpriseShell,
  EnterpriseTopBar,
  WarningBanner
} from './ui/EnterpriseLayout';

function SelectIDType() {
  const navigate = useNavigate();
  const [showWarning, setShowWarning] = React.useState(true);
  const [selectedCountry, setSelectedCountry] = React.useState('');
  const [selectedDocument, setSelectedDocument] = React.useState('');

  return (
    <EnterpriseShell>
      <EnterpriseTopBar
        right={
          <>
            <BackButton onClick={() => navigate(-1)} />
            <span className="vt-chip vt-chip--subtle">ID verification</span>
          </>
        }
      />

      <EnterpriseHero
        kicker="Document capture"
        meta="Step 1 of 2"
        title="Select your document"
        subtitle="Choose the issuing country and document type. You’ll take a photo in the next step."
      />

      <EnterpriseGrid>
        <EnterpriseCard>
          <div className="select-id-dropdown-wrapper">
            <select
              className="select-id-dropdown"
              value={selectedCountry}
              onChange={(e) => {
                setSelectedCountry(e.target.value);
                setSelectedDocument('');
              }}
            >
              <option value="">Select issuing country</option>
              <option value="US">United States</option>
              <option value="GB">United Kingdom</option>
              <option value="CA">Canada</option>
              <option value="AU">Australia</option>
              <option value="IE">Ireland</option>
            </select>
          </div>

          {selectedCountry && (
            <div className="select-id-dropdown-wrapper document-dropdown-wrapper">
              <select
                className="select-id-dropdown document-dropdown"
                value={selectedDocument}
                onChange={(e) => setSelectedDocument(e.target.value)}
              >
                <option value="">Select document</option>
                <option value="passport">Passport</option>
                <option value="driving-licence">Driving licence</option>
                <option value="passport-card">Passport card</option>
                <option value="residence-permit">Residence permit</option>
                <option value="none">I don&apos;t have any of these documents</option>
              </select>
            </div>
          )}

          <div className="vt-actions">
            <EnterpriseButton
              variant="primary"
              onClick={() => navigate('/capture-instructions')}
              disabled={!selectedCountry || !selectedDocument}
            >
              <span>Continue</span>
              <ArrowForwardRounded className="vt-btnIcon" />
            </EnterpriseButton>
            <EnterpriseButton variant="secondary" type="button" onClick={() => navigate('/')}>
              Back to options
            </EnterpriseButton>
          </div>
        </EnterpriseCard>

        <EnterpriseCard>
          {showWarning && (
            <div style={{ marginBottom: 14 }}>
              <WarningBanner onClose={() => setShowWarning(false)}>
                For security reasons this session will expire in 10 minutes.
              </WarningBanner>
            </div>
          )}

          <div className="vt-cardHeader">
            <div className="vt-iconTile" aria-hidden="true">
              <OpenInNew className="vt-iconTileIcon" />
            </div>
            <div>
              <h3 className="vt-cardTitle">Your privacy</h3>
              <p className="vt-cardDescription">
                Learn how Veritage securely uses the details you provide during verification.
              </p>
            </div>
          </div>

          <EnterpriseButton variant="secondary" type="button" onClick={(e) => e.preventDefault()}>
            <span>Privacy policy</span>
            <OpenInNew className="vt-btnIcon" />
          </EnterpriseButton>
        </EnterpriseCard>
      </EnterpriseGrid>
    </EnterpriseShell>
  );
}

export default SelectIDType;
